import { uri } from '../../api-endpoint';
import {
  ILabelAPIValidationError,
  ILabelFromAPISuccessResponse
} from '../../type-conversion/label/from-api-repsonse';
import { LabelAPIRequestBody } from '../../type-conversion/label/to-api-request-body';
import { updateTemplateFn } from '../common';

export const updateModelLabel = (token: string) => (
  modelId: number,
  labelId: number
) =>
  updateTemplateFn(
    token,
    uri.modelLabelById(modelId, labelId),
    LabelAPIRequestBody,
    ILabelFromAPISuccessResponse,
    ILabelAPIValidationError
  );
